<template>
    <div>
        <div class='white--text text-md-subtitle-1 py-2 px-2 primary'>
            <b>
                <v-icon class="white--text" style="position: relative;top: -3px;">mdi-map-marker</v-icon> INGRESE LOS DATOS DE SU NUEVA DIRECCIÓN
            </b>
        </div>    
        <v-form ref='from_direction_client'>
            <v-col>
                <v-row>
                    <v-col>
                        <v-col class='py-0'>
                            <v-autocomplete
                                autofocus
                                v-model=province
                                :items=provinces
                                item-value='geo_id'
                                item-text='geo_name'
                                dense
                                rounded
                                outlined
                                label='Seleccione la provincia'
                                prepend-inner-icon='mdi-map'
                                :rules=requiredRule
                                @change="getDataAutocomplete(`${province}/parroquias-provincia`,'states')"
                            ></v-autocomplete>
                        </v-col>
                        <v-col class='py-0'>
                            <v-autocomplete
                                ref="input_change"
                                v-model=state
                                :items=states
                                item-value='parroquia_id'
                                item-text='parroquia'
                                dense
                                rounded
                                outlined
                                label='Seleccione la ciudad'
                                prepend-inner-icon='mdi-city'
                                return-object
                                :rules=requiredRule
                                @change="getDataAutocomplete(`${state.canton_id}/sectores-canton`,'sector')"
                            ></v-autocomplete>
                        </v-col>
                        <v-col class='py-0'>
                            <v-autocomplete
                                v-if=autoCompleteSector
                                v-model=sector
                                :items=sectors
                                item-value='id'
                                item-text='nombre'
                                dense
                                rounded
                                outlined
                                label='Seleccione el sector'
                                prepend-inner-icon='mdi-city'
                                :rules=requiredRule
                                @change="setShippingPoint"
                            ></v-autocomplete>
                            <v-text-field
                                v-else
                                v-model=sector
                                dense
                                rounded
                                outlined
                                label='Escriba el sector'
                                prepend-inner-icon='mdi-city'
                                :rules=requiredRule
                                @keyup="setShippingPoint"
                            ></v-text-field>
                        </v-col>
                        <v-col class='py-0'>
                            <v-text-field
                                v-model=street
                                dense
                                rounded
                                outlined
                                label='Calle principal y número'
                                prepend-inner-icon='mdi-map-marker-radius'
                                :rules=requiredRule
                                @keyup="setShippingPoint"
                            ></v-text-field>
                        </v-col>
                        <v-col class='py-0'>
                            <v-text-field
                                v-model=street2
                                dense
                                rounded
                                outlined
                                label='Calle secundaria'
                                prepend-inner-icon='mdi-map-marker-radius'
                                :rules=requiredRule
                                @keyup="setShippingPoint"
                            ></v-text-field>
                        </v-col>
                        <v-col class='py-0'>
                            <v-textarea
                                v-model=reference
                                outlined
                                rounded
                                label='Referencias'
                                :rules=requiredRule
                            ></v-textarea>
                        </v-col>
                    </v-col>
                </v-row>
            </v-col>
            <v-col class='text-center pt-0'>
            <v-btn 
                color='primary'
                @click=emitStoreDirection
                small
            > 
                <v-icon>mdi-content-save</v-icon> Guardar 
            </v-btn>
            <v-btn 
                color='default'
                @click=close
                small
            > 
                <v-icon>mdi-cancel</v-icon> Cerrar 
            </v-btn>
        </v-col>
        </v-form>
        
      </div>
  </template>
  
  <script>
  
  var interval=""
  
  import { mapMutations, mapState, mapActions } from "vuex";
  
  export default {
        name: 'CaptureDirection',
        props:{
            dataDirection:{
                type: Object,
                default: () => {}
            }
        },
        data: () => ({
            saveDirection:false,
            street:null,
            street2:null,
            direction:null,
            billingDirection:true,
            province:null,
            state:null,
            sector:null,
            reference:null,
            autoCompleteSector: true,
            provinces:[],
            states:[],
            sectors:[],
            requiredRule:[
                v => !!v || 'El campo es requerido'
            ]
        }),
        computed:{
  
            ...mapState(['partyIdClient','quoteId']),
    
            ...mapState(['objGeoCoding'])
    
        },
        watch:{

            province(val){
              
                this.getDataAutocomplete(`${val}/parroquias-provincia`,'states')
                .then(()=>{
                    
                    if(typeof this.dataDirection != 'undefined' && typeof this.dataDirection.geo_id != 'undefined'){
                        let st = this.states.find(e => e.parroquia_id == this.dataDirection.parroquia_geo_id)
                        this.state= st
                    }
                })

            },

            state(val){
                          
                this.getDataAutocomplete(`${val.canton_id}/sectores-canton`,'sector')
                .then(()=>{
                    if(typeof this.dataDirection != 'undefined' && typeof this.dataDirection.geo_id != 'undefined')
                        this.sector = parseInt(this.dataDirection.sector)
                })
        
            }   

        },
        methods: {
            
            ...mapMutations(['mapMutations','setUrl']),

            ...mapActions(['requestApi']),

            close(){
                this.$emit('close')
                this.street= null
                this.street2= null
                this.direction= null
                this.billingDirection=null
                this.province= null
                this.state= null
                this.sector= null
                this.reference= null
                this.provinces = []
                this.states = []
                this.sectors = []
            },

            getDataAutocomplete(url,input){
               
                return new Promise(resolve =>{

                    this.setUrl(`geo/${url}`)
                    this.requestApi({
                        method: 'GET',
                        data:{
                            tenantId: process.env.VUE_APP_TENANT
                        } 
                    }).then(res => {
                      
                        if(input === 'provinces'){
                            this.provinces= res.data.detail
                        }else if(input === 'states'){
                            this.states= res.data.detail
                        }else{
                            this.sectors = res.data.detail
                            this.autoCompleteSector = res.data.detail.length
                        }

                        resolve()
                    })

                })

                

            },

            setShippingPoint(){

                /*if(!this.action){
                    clearInterval(interval)
                    this.saveDirection=false
                    let province = this.provinces.find(e => e.geo_id == this.state.provincia_id)
                    let sector = this.sectors.find(e => e.id == this.sector)
                    let direction = (this.sector == null ? '' : (typeof this.sector =='number' ? sector.nombre : this.sector) )+' '+(this.street == null ? '' : this.street)+' '+(this.street2 == null ? '': this.street2)+' '+this.state.parroquia+' '+province.geo_name

                    interval = setTimeout(()=>{
                        this.pointShippment= []
                        this.objGeoCoding.provider.search({query:direction})
                        .then(res => {
                            console.log(res)
                            this.pointShippment.push({
                                latLng:[res[0].y,res[0].x],
                                label:res[0].label
                            })
                            this.$emit('point', this.pointShippment)
                            this.saveDirection=true
                        })
                    },1000)
                }*/

            },

            emitStoreDirection(){
               
                if(!this.$refs.from_direction_client.validate())
                    return false

                let sectorObj = this.sectors.find(e => e.id == this.sector)
                let sectorName = typeof sectorObj != 'undefined' ? sectorObj.id : this.sector
                let province = this.provinces.find(e => e.geo_id == this.province)

                this.$emit('storeDirection',{
                    provinceName: typeof province !='undefined' ?  province.geo_name : '',
                    province: this.province,
                    state: this.state,
                    street: this.street,
                    secondaryStreet: this.street2,
                    sector: sectorName,
                    reference: this.reference,
                    pointShippment: this.pointShippment,
                })

                this.street= null
                this.street2= null
                this.direction= null
                this.billingDirection=null
                this.province= null
                this.state= null
                this.sector= null
                this.reference= null
                this.provinces = []
                this.states = []
                this.sectors = []

            },
            
        },
        created(){
          
            this.getDataAutocomplete('ECU/provincias-pais','provinces')
            .then(()=>{

                if(typeof this.dataDirection != 'undefined' && typeof this.dataDirection.geo_id != 'undefined'){

                    const {geo_id, address1, calle_secundaria, observaciones} = this.dataDirection

                    this.province = geo_id
                    this.street =address1
                    this.street2 =calle_secundaria
                    this.reference = observaciones

                }

            })
        }

    }
</script>